function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 2H10C8.34315 2 7 3.34314 7 5V15C7 16.6569 8.34314 18 10 18H18C19.6569 18 21 16.6569 21 15V5C21 3.34315 19.6569 2 18 2ZM9 5C9 4.44772 9.44772 4 10 4H18C18.5523 4 19 4.44772 19 5V15C19 15.5523 18.5523 16 18 16H10C9.44771 16 9 15.5523 9 15V5Z",
  fill: "#878793"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 20C16.5523 20 17 20.4477 17 21C17 21.5523 16.5523 22 16 22H6C4.34315 22 3 20.6569 3 19V7C3 6.44772 3.44772 6 4 6C4.55228 6 5 6.44772 5 7V19C5 19.5523 5.44772 20 6 20H16Z",
  fill: "#878793"
});

function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.de5864c3.svg";
export { ForwardRef as ReactComponent };